import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-permit-section-block',
    templateUrl: './permit-section-block.component.html',
    styleUrls: ['./permit-section-block.component.scss'],
})
export class PermitSectionBlockComponent {
    @Input() title: string = '';
}
